<template>

    <fragment v-if="!slide.question.allow_multi_answers_scale">
        <label v-if="slide.question.options.length === 0" ><input v-model="dataStore.currentOpinion.values" type="radio" v-on:change="changeRadioValue" class="form-control" name="question" value="[1001]" :title="language.strongly_disagree" >{{ language.strongly_disagree }}</label>
        <label v-if="slide.question.options.length === 0" ><input v-model="dataStore.currentOpinion.values" type="radio" v-on:change="changeRadioValue" class="form-control" name="question" value="[1002]" :title="language.disagree" >{{ language.disagree }}</label>
        <label v-if="slide.question.options.length === 0" ><input v-model="dataStore.currentOpinion.values" type="radio" v-on:change="changeRadioValue" class="form-control" name="question" value="[1003]" :title="language.neither" >{{ language.neither }}</label>
        <label v-if="slide.question.options.length === 0" ><input v-model="dataStore.currentOpinion.values" type="radio" v-on:change="changeRadioValue" class="form-control" name="question" value="[1004]" :title="language.partially_agree" >{{ language.partially_agree }}</label>
        <label v-if="slide.question.options.length === 0" ><input v-model="dataStore.currentOpinion.values" type="radio" v-on:change="changeRadioValue" class="form-control" name="question" value="[1005]" :title="language.fully_agree" >{{ language.fully_agree }}</label>

        <fragment v-if="slide.question.options.length > 0 && dataStore.project">
            <label v-for="(option, i) in  slide.question.options.filter(opt => opt.type === 'scale')" :key="`option-scale-${i}`">
                <input v-model="dataStore.currentOpinion.values" type="radio" :title="option.value" v-on:change="changeRadioValue" class="form-control" name="question" :value="`[${option.id}]`">
                {{ option.value }}
            </label>
        </fragment>

    </fragment>

    <fragment v-else>

        <fragment v-if="slide.question.options.length > 0 && dataStore.project">
            <label class="form-check-label multiple" v-for="(option, i) in  slide.question.options.filter(opt => opt.type === 'scale')" :key="`option-scale-${i}`">
                <input v-on:change.prevent="multiAnswer" type="checkbox" :title="option.value" class="form-check-input" name="question" :value="option.id">
                {{ option.value }}
            </label>
        </fragment>

        <label v-if="slide.question.options.length === 0" class="form-check-label multiple"><input v-on:change.prevent="multiAnswer" type="checkbox" class="form-check-input" name="question" value="1001" :title="language.strongly_disagree" >{{ language.strongly_disagree }}</label>
        <label v-if="slide.question.options.length === 0" class="form-check-label multiple"><input v-on:change.prevent="multiAnswer" type="checkbox" class="form-check-input" name="question" value="1002" :title="language.disagree" >{{ language.disagree }}</label>
        <label v-if="slide.question.options.length === 0" class="form-check-label multiple"><input v-on:change.prevent="multiAnswer" type="checkbox" class="form-check-input" name="question" value="1003" :title="language.neither" >{{ language.neither }}</label>
        <label v-if="slide.question.options.length === 0" class="form-check-label multiple"><input v-on:change.prevent="multiAnswer" type="checkbox" class="form-check-input" name="question" value="1004" :title="language.partially_agree" >{{ language.partially_agree }}</label>
        <label v-if="slide.question.options.length === 0" class="form-check-label multiple"><input v-on:change.prevent="multiAnswer" type="checkbox" class="form-check-input" name="question" value="1005" :title="language.fully_agree" >{{ language.fully_agree }}</label>

    </fragment>

</template>

<script>

import { Fragment } from "vue-fragment";

import dataStore from "../../store";

export default {

    inject: [ 'language' ],

    components: {
        Fragment
    },

    data() {
        return {
            dataStore,
            isDisabled : false
        };
    },

    mounted() {
        this.beforeChange()
        // this.afterChange()
    },

    computed : {

        limit: function() {
            return this.slide && this.slide.question && this.slide.question.limit_markers
        },

        toManyChecked : function() {
            return this.isDisabled
        }
    },

    props: {
        slide : Object
    },

    methods : {

        multiAnswer: function(e) {

            const anyChecked = document.querySelectorAll('.slick-active input[name="question"]:checked');

            if( this.limit ) {

                const limitReached = anyChecked.length > this.slide.amount_of_answers

                if( ! limitReached ) {
                    this.$emit('multi-value', this.mapValues(anyChecked))
                }

                this.$emit('limit-reached', limitReached)

                this.isDisabled = true
            }

            else {
                this.$emit('multi-value', this.mapValues(anyChecked))
            }

            if(anyChecked.length > 0) {
                this.$emit('is-disabled', false)
            } 
            
            else {

                this.$emit('is-disabled', true)

                let index = this.dataStore.collectedAnswers.findIndex(item => item.item_id === this.slide.id )

                if(index >= 0) {

                    this.dataStore.collectedAnswers.splice(index, 1)

                    this.dataStore.currentOpinion.values = []

                }
            }

        },

        mapValues: function(nodeList) {

            return Array.from(nodeList).map(el => {

                return {
                    slide : this.slide.id,
                    id : Number(el.value),
                    checked : el.checked
                }

            })

        },

        changeRadioValue: function() {
            this.$emit('is-disabled', false)
        },

        removeCheckedNotInBag: function(id) {

            if( this.dataStore.collectedAnswers.length > 0 ) {

                const items = this.dataStore.collectedAnswers.filter(item => item.item_id == id)

                const checkedIds = []

                for (const property in items) {

                    const item = items[property]

                    for (const collected of item.values) {
                        
                        if(collected.slide == id) {
                            checkedIds.push(collected.id)
                        }

                    }


                }

                // uncheck checkboxes on slide if not commited to bag

                const checkboxes = document.querySelectorAll(`.slide-item-${id} .form-check-label.multiple`)

                for(const el of Array.from(checkboxes)) {

                    const input = el.querySelector('input')

                    const val = parseInt(input.value)

                    if( ! checkedIds.includes(val) ) {
                        input.checked = false
                    }
                    
                }
                
                this.$emit('limit-reached', false)
            }


            // kolla om det finns några valda på befintlig slide så fall unchecka dem 

        },

        beforeChange: function() {

            this.$parent.$parent.$parent.$on('beforeChange', (event, slick, currentSlide, nextSlide) => {

                if( this.limit ) {
                    let id = slick.$slides[nextSlide].children[0].children[0].getAttribute("data-slideid")
                    this.removeCheckedNotInBag(id)
                }

            })

        },

        // afterChange: function() {

        //     this.$parent.$parent.$parent.$on('afterChange', (event, slick, currentSlide) => {
        //         // let currentItemID = slick.$slides[currentSlide].children[0].children[0].getAttribute("data-slideid")
        //     })

        // }
    }
};
</script>

